import { render, staticRenderFns } from "./LessonCourseInChargeForm.vue?vue&type=template&id=962f95aa&scoped=true&"
import script from "./LessonCourseInChargeForm.vue?vue&type=script&lang=js&"
export * from "./LessonCourseInChargeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962f95aa",
  null
  
)

export default component.exports